<template>
  <div class="main_">
    <top-header :type="6" placeholder="实名认证" fontSize="0.32rem" />
    <div class="one" v-if="state === 0">
      <van-field
        readonly
        clickable
        name="picker"
        :value="valueText"
        label="证件类别"
        placeholder="点击证件类别"
        @click="showPicker = true"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          value-key="t"
          :columns="columns"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>
      <h5>上传身份证</h5>
      <div class="pic_con">
        <van-uploader :before-read="beforeRead" :after-read="afterRead" >
          <img :src="img1" alt="" class="small">
        </van-uploader>
        <p>头像面</p>
      </div>
      <div class="pic_con">
        <van-uploader :before-read="beforeRead" :after-read="afterRead1" >
          <img :src="img2" alt="" class="small">
        </van-uploader>
        <p>国徽面</p>
      </div>
      <div class="btn_con">
        <van-button block type="info" @click="submitOne" >
          点击确定
        </van-button>
      </div>
    </div>
    <div class="two" v-if="state === 1">
      <p class="tips">*请核对您身份证识别的信息</p>
      <van-field
        readonly
        v-model="realName"
        name="用户名"
        label="姓名"
        placeholder="用户名"
      />
      <van-field
        readonly
        v-model="idCard"
        type="text"
        name="密码"
        label="证件号"
        placeholder="密码"
      />
      <div class='van-cell van-field'>
        <p class="van-cell__title van-field__label">地址</p>
        <p class="van-cell__value van-field__value">
          <span class="van-field__control">{{address}}</span>
        </p>
      </div>
      <div class="btn_con">
        <van-button block type="info" @click="submitTwo">
          确认无误
        </van-button>
        <van-button block plain type="info" @click="hasWrong">
          信息有误
        </van-button>
      </div>
    </div>
    <div class="three" v-if="state === 2">
      <img src="@/assets/img/test3.png" alt="">
      <div class="btn_con">
        <van-button block type="info" native-type="submit" @click="sendCode">
          下一步
        </van-button>
      </div>
    </div>
    <van-overlay :show="show" @click="hideCover" class="flex_v flex_vc flex_hc" >
      <div class="block" @click.stop>
        <h5>请牢记以下验证码</h5>
        <p>此验证码将于<span>{{codeTime}}</span>秒后过期</p>
        <p>用普通话朗读数字，视频时长<span>3-6</span>秒最佳</p>
        <div class="inner m_flex_box flex_hc flex_vc">
          <span v-for="(item, index) in codeArr" :key="index">{{item}}</span>
        </div>
        <div class="btn_con">
          <van-uploader type="file" accept="video/*" capture="camcorder" :after-read="confirmVideo">
            <van-button block type="info">
              记住了开始录制
            </van-button>
          </van-uploader>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import qs from 'qs'
import topHeader from '@/components/header';
let timmer = null;
let setTimer = null;
export default {
  data() {
    return {
      show: false,
      valueText: '第二代居民身份证',
      value: 0,
      columns: [{
        t: '第二代居民身份证',
        v: 0
      },{
        t: '临时居民身份证',
        v: 1
      }],
      showPicker: false,
      img1: require('@/assets/img/u1.png'),
      img2: require('@/assets/img/u2.png'),
      image1: '',
      image2: '',
      realName: '',
      idCard: '',
      address: '',
      state: 0,
      codeTime: 180,
      codeArr: [],
      path:'',
    };
  },
  components: {
    topHeader,
  },
  mounted() {
    console.log(this.$route.query.path)
    this.path = this.$route.query.path
    this.getState();
  },
  methods: {
    confirmVideo(file) {
      if((file.file.size / (1024 * 1024)) > 30) {
        this.$toast('视频大小超过限制,视频时间,建议在3-6秒');
        this.show = false
      } else {
        clearInterval(setTimer)
        this.show = false;
        setTimeout(() => {
          this.codeTime = 180;
        }, 500);
        const formData = new FormData();
        formData.append("id", this.$route.query.id);
        formData.append("video", file.file);
        this.$http({
          url: 'cms/faceverify/permit/getFaceverifyVideo.do',
          method: 'POST',
          headers: { //添加请求头
            "Content-Type": "multipart/form-data",
          },
          data: formData,
        }).then(res => {
          if(res.success) {
            this.$dialog.alert({
              title: '提示',
              message: res.msg,
            }).then(() => {
              this.show = false
              if (!this.path){
                this.$dialog.alert({
                  title: '提示',
                  message: '认证完成!',
                }).then(() => {
                  this.$router.go(-1)
                })
              }else{
                this.$dialog.alert({
                  title: '提示',
                  message: '认证完成!',
                }).then(() => {
                  this.$router.replace(this.path);
                })
              }
            })
          } else {
            this.$dialog.alert({
              title: '提示',
              message: res.msg,
            })
          }
        })
      }
    },
    sendCode() {
      if (this.codeTime === 180) {
        this.$http.post('cms/faceverify/permit/getSessioncode.do', qs.stringify({
          id: this.$route.query.id,
        })).then(res => {
          this.show = true;
          const codeArr = res.obj.split('');
          this.codeArr = codeArr;
          this.codeTime -= 1
          setTimer = setInterval(() => {
            if (this.codeTime > 0) {
              this.codeTime -= 1
            } else {
              clearInterval(setTimer)
              this.show = false;
              setTimeout(() => {
                this.codeTime = 180;
              }, 500);
              this.$dialog.alert({
                title: '提示',
                message: '验证码已过期,请重新验证'
              })
            }
          }, 1000);
        })
      }
    },
    hideCover() {
      this.show = false;
      clearInterval(setTimer);
      setTimeout(() => {
        this.codeTime = 180;
      }, 500);
    },
    getState() {
      this.$http.post('cms/faceverify/permit/getState.do', qs.stringify({
        id: this.$route.query.id
      })).then(res => {
        if (res.success) {
            if (res.obj == 0) {
              this.state = 0
            } else if (res.obj == 1) {
              //读取1 的信息
              this.getInfo();
            } else if (res.obj == 2) {
              this.state = 2;
            } else if (res.obj == 3) {
              this.state = 3;
                this.$dialog.alert({
                  title: '提示',
                  message: '您已完成活体验证识别，请勿重复尝试',
                });
            } else {
              this.$dialog.alert({
                title: '提示',
                message: '活体验证参数错误，无法继续，请重试',
              });
            }
        } else {
          this.$dialog.alert({
            title: '提示',
            message: res.msg,
          });
        }
      })
    },
    onConfirm(value) {
      this.value = value.v;
      this.valueText = value.t;
      this.showPicker = false;
    },
    beforeRead(file) {
      if (file.type.toLowerCase() !== 'image/jpg' && file.type.toLowerCase() !== 'image/png' && file.type.toLowerCase() !== 'image/jpeg' && file.type.toLowerCase() !== 'image/gif') {
        this.$toast('该格式不支持');
        return false;
      } else if (file.size > 5000 * 1024) {
        this.$toast('文件大小不得超过5M');
        return false;
      }
      return true;
    },
    afterRead(file) {
      this.img1 = file.content;
      this.image1 = file.file
    },
    afterRead1(file) {
      this.img2 = file.content;
      this.image2 = file.file
    },
    getInfo() {
      this.$http.post('cms/faceverify/permit/getInfo.do', qs.stringify({
        id: this.$route.query.id
      })).then(res => {
        this.idCard = res.obj.idCard;
        this.realName = res.obj.realName;
        this.address = res.obj.address;
        this.state = 1;
      })
    },
    submitOne() {
      if(!this.image1) {
        this.$toast('请上传身份证头像面图');
        return;
      } else if(!this.image2) {
        this.$toast('请上传身份证国徽面图');
        return;
      }
      const formData = new FormData;
      formData.append('id', this.$route.query.id);
      formData.append('file1', this.image1);
      formData.append('file2', this.image2);
      formData.append('idCardType', this.value);
      this.$http({
        url: 'cms/faceverify/permit/getIdcardImg.do',
        method: 'POST',
        headers: { //添加请求头
          "Content-Type": "multipart/form-data",
        },
        data: formData,
      }).then(res => {
        if (res.success) {
          if (this.value == 0) {
            this.getInfo();
          } else if (this.value == 1) {
            this.state = 2;
          }
        } else {
          this.$dialog.alert({
            title: '提示',
            message:res.msg,
          });
        }
      })
    },
    submitTwo() {
      this.$http.post('cms/faceverify/permit/affirmIdCardImgInfo.do', qs.stringify({
        id:this.$route.query.id,
        affirm: 1
      })).then(res => {
        this.$dialog.alert({
          title: '提示',
          message:res.msg,
        }).then(() => {
          this.state = 2;
        });
      })
    },
    hasWrong() {
      this.$http.post('cms/faceverify/permit/affirmIdCardImgInfo.do', qs.stringify({
        id:this.$route.query.id,
        affirm: 0
      })).then(res => {
        this.$dialog.alert({
          title: '提示',
          message:res.msg,
        }).then(() => {
          this.state = 0;
          this.img1 = require('@/assets/img/u1.png');
          this.img2 = require('@/assets/img/u2.png');
          this.image1 = '';
          this.image2 = '';
        });
      })
    },
  },
};
</script>
<style lang="less" scoped>
.form_con{
  padding: 0.3rem 0rem;
}
.one{
  .pic_con{
    padding: 16px 16px;
    position: relative;
    .small{
      width: 2.56rem;
      height: 1.63rem;
    }
  }
  p{
    color: #474747;
    font-size: 12px;
    width: 2.56rem;
    text-align: center;
    margin-top: 0.1rem;
    color: #666;
  }
  .btn_con{
    padding: 10vh 0.26rem 0.4rem;
  }
}
h5{
  font-size: 0.3rem;
  padding: 10px 16px 0;
  color: #646566;
  font-weight: 800;
}
.two{
  .tips{
    color: #F50707;
    font-size: 0.22rem;
    padding: 10px 16px;
  }
  p{
    /deep/
    &.van-cell__value{
      text-align: left;
    }
  }
  .btn_con{
    padding: 10vh 0.26rem 0.4rem;
    /deep/
    .van-button{
      margin-bottom: 0.2rem;
    }
  }
}
.three{
  img{
    width: 100%;
    display: block;
  }
  .btn_con{
    padding: 10vh 0.26rem 0.4rem;
  }
}
.block{
  background-color: #fff;
  padding: 0.4rem 0.18rem 0.18rem;
  border-radius: 0.06rem;
  text-align: center;
  h5{
    font-size: 0.28rem;
    margin-bottom: 0.22rem;
  }
  p{
    font-size: 0.26rem;
    color: #666666;
    span{
      color: #F50707;
    }
  }
  .inner{
    margin: 0.4rem 0.6rem;
    span{
      width: 0.9rem;
      height: 0.9rem;
      border-radius: 0.1rem;
      line-height: 0.9rem;
      border: 1px solid #CCCCCC;
      font-size: 0.72rem;
      margin: 0 0.06rem;
    }
  }
}
</style>